import { useMemo } from 'react';

import {
  FormProps,
  ProductStoreHeader,
} from 'src/routes/billing/store/components/ProductStoreHeader';
import { ProductStoreSchema } from 'src/routes/billing/store/schema';

interface Props {
  onClick: (data: ProductStoreSchema, isPublish: boolean) => Promise<void>;
  shareProductStoreModalOpen: boolean;
  onShareProductStoreModal: (open: boolean) => void;
  isProductStoreLoading: boolean;
  onCopyDomainUrl: () => void;
  basePortalDomain: string;
}
export const useProductStoreFormHeader: ({
  onClick,
  shareProductStoreModalOpen,
  onShareProductStoreModal,
  isProductStoreLoading,
  onCopyDomainUrl,
  basePortalDomain,
}: Props) => (props: FormProps) => JSX.Element = ({
  onClick,
  shareProductStoreModalOpen,
  onShareProductStoreModal,
  isProductStoreLoading,
  onCopyDomainUrl,
  basePortalDomain,
}) => {
  const component = useMemo(
    () => (props: FormProps) => (
      <ProductStoreHeader
        onClick={onClick}
        shareProductStoreModalOpen={shareProductStoreModalOpen}
        onShareProductStoreModal={onShareProductStoreModal}
        isProductStoreLoading={isProductStoreLoading}
        onCopyDomainUrl={onCopyDomainUrl}
        basePortalDomain={basePortalDomain}
        {...props}
      />
    ),
    [
      onClick,
      shareProductStoreModalOpen,
      onShareProductStoreModal,
      isProductStoreLoading,
      onCopyDomainUrl,
      basePortalDomain,
    ],
  );

  return component;
};
